export default __webpack_public_path__ + "static/media/leaguePro2.f334037f.jpg";